export default __webpack_public_path__ + "static/media/341.d5b09f2d.png";